/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageNamespaceRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageNamespace/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
